var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgLinkOverUi = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_666_2077)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36 4V0H28V4V34.3375L18.825 25.1625L16 22.3375L10.3375 28L13.1625 30.825L29.1625 46.825L32 49.6625L34.825 46.8375L50.825 30.8375L53.6625 28L48 22.3375L45.175 25.1625L36 34.3375V4ZM0 64H64V44H43.3125L37.65 49.6625L32 55.3125L26.3375 49.65L20.6875 44H0V64ZM54 51C54.7957 51 55.5587 51.3161 56.1213 51.8787C56.6839 52.4413 57 53.2043 57 54C57 54.7957 56.6839 55.5587 56.1213 56.1213C55.5587 56.6839 54.7957 57 54 57C53.2043 57 52.4413 56.6839 51.8787 56.1213C51.3161 55.5587 51 54.7957 51 54C51 53.2043 51.3161 52.4413 51.8787 51.8787C52.4413 51.3161 53.2043 51 54 51Z",
    fill: "url(#paint0_linear_666_2077)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_666_2077",
    x: 0,
    y: 0,
    width: 64,
    height: 65.6152,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.61516
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.807578
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_666_2077"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_666_2077",
    x1: 56.1167,
    y1: 77.6844,
    x2: -5.02615,
    y2: 67.4378,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8E3DE",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.333333,
    stopColor: "#E8E3DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.666667,
    stopColor: "#E8E3DE",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8E3DE"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLinkOverUi, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/link-over-ui.1b9bcc38.svg";
export { ForwardRef as ReactComponent };